import React from 'react';
import HyperlinkElement from "./components/Hyperlink";
import HyperlinkSettings from "./components/HyperlinkSettings";
import { ReactComponent as HyperlinkSvg } from '@assets/icons/link.svg';
import { getLocale } from '@utils/util';

export default () => {
  const messages = getLocale();
  return {
    name: 'hyperlink',
    title: messages['PAGEBUIDER_ELEMENT_FORM_HYPERLINK'], // 插件标题
    toolBarPreview: <HyperlinkSvg />, // 插件展示图标，不传则展示文字
    data: {
      formItemSettings: {
        text: messages['PAGEBUIDER_ELEMENT_FORM_HYPERLINK'],
        fontSize: 14,
        href: '#',
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_HYPERLINK']
      },
      settings: {
        width: {
          value: "100%"
        },
        margin: {
          desktop: { all: 0 },
          mobile: { all: 0 },
          advanced: true
        },
        padding: {
          desktop: { top: 5, left: 0, right: 0, bottom: 5 },
          mobile: { top: 5, left: 0, right: 0, bottom: 5 },
          advanced: true
        }
      }
    },
    pluginComponent: HyperlinkElement, // 插件渲染组件
    pluginSettingComponent: HyperlinkSettings, // 插件设置项组件
  }
}
